module.exports = __webpack_public_path__ + "static/media/Leccion-9-17-GDV-Enfocados-con-Proposito.2b41def2.pdf";